import React from 'react'
import { Form, Select } from 'antd'
import { connect, useSelector } from 'react-redux'

const { Option } = Select
export interface IFormProps {
  setParams: (params?: any, p?: string) => void
}
const FormItem = Form.Item
const MerchantForm = (props: IFormProps) => {
  const { setParams } = props
  const merchants = useSelector<any>(store => store.baseData.merchants) as any
  const changeMerchant = merchantId => {
    setParams({
      m: merchantId,
    })
  }
  return (
    <FormItem label="选择商家">
      <Select onChange={changeMerchant} showSearch optionFilterProp="children">
        {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
        {merchants.map((item: any, index) => {
          return (
            <Option value={item.id} key={item.id}>
              {item.label}
            </Option>
          )
        })}
      </Select>
    </FormItem>
  )
}

const mapStateToProps = store => {
  return {
    merchants: store.baseData.merchants,
  }
}

export default connect(mapStateToProps)(MerchantForm)
